import cn from "classnames";
import React from "react";
import Spinner from "../Spinner";

type ButtonColor = "primary" | "secondary" | "danger" | "transparent";
type ButtonSize = "sm" | "md" | "lg";

type ButtonProps = React.ComponentProps<"button"> & {
  color?: ButtonColor;
  size?: ButtonSize;
  block?: boolean;
  loading?: boolean;
};

const Button = ({
  color = "primary",
  size = "md",
  block,
  className,
  disabled,
  children,
  loading,
  ...props
}: ButtonProps) => {
  let btnColor, btnSize;

  if (disabled || loading) {
    btnColor = "bg-gray-400 text-white";
  } else if (color === "secondary") {
    btnColor = "bg-secondary text-white";
  } else if (color === "danger") {
    btnColor = "bg-red-500 text-white";
  } else if (color === "transparent") {
    btnColor = "bg-transparent text-primary border border-primary border-solid";
  } else {
    btnColor = "bg-primary text-white";
  }

  let lineHeight;
  if (size === "sm") {
    btnSize = "text-sm px-4 py-1 rounded";
    lineHeight = 20;
  } else if (size === "md") {
    btnSize = "text-sm px-6 py-2 rounded-md";
    lineHeight = 24;
  } else {
    btnSize = "text-base px-8 py-2 rounded-lg";
    lineHeight = 28;
  }

  return (
    <button
      className={cn(
        "focus:outline-none focus:ring-2 ring-primary ring-opacity-40 font-medium",
        { "w-full": block },
        btnColor,
        btnSize,
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {!loading && children}
      {loading && (
        <div
          className="w-full flex justify-center"
          style={{ height: lineHeight, minHeight: lineHeight }}
        >
          <Spinner size={lineHeight} line={2} />
        </div>
      )}
    </button>
  );
};

export default Button;
